export default __webpack_public_path__ + "static/media/room.c021c900.jpg";